import { getWeekData } from "@api/user";
import { showWindowMessage } from "@utils/notification";

export default {
  data() {
    return {
      scheduleData: [],
    };
  },

  methods: {
    /**
     * 获取所有的id
     * @param {string} type - 时间 早班 晚班 夜班
     * @param {Object} scheduleData - 要处理的数据
     * @return {Object} - 拿到的所有需要数据
     * */
    getAllIds(scheduleData, type) {
      const timeData = scheduleData.map(item => item.events[type]);
      const allIds = [];

      timeData.forEach((item) => {
        const persons = item.room.flatMap((roomItem) => roomItem.persons);
        const usersIds = persons.map((person) => person.id);
        const data = {
          users: usersIds,
          date: item.date,
          id: item.id
        };
        allIds.push(data);
      });
      return allIds;
    },
    /**
     * 获取一周所有的排版
     * @param {string} date - 日期  格式 2023-04-17
     * */
    async getWeekPlanDetail(date) {
      const postTime = this.selectWeek.split("-")[0].replaceAll(".", "-");

      try {
        const { code, data, msg } = await getWeekData({ identify: postTime });
        if (code !== 200) {
          showWindowMessage(3, msg, this);
        }
        const [allMorning, allNight, allMidnight] = data;
        this.scheduleData = [];
        for (let day = 0; day < 7; day++) {
          const oneDay = {
            date: allMorning[day].date.split("-")[2],
            month: allMorning[day].date.split("-")[1],
            dayWeek: this.weekNum2Day[allMorning[day].weekday],
            events: {
              morning: { ...allMorning[day], name: "早班", room: [] },
              night: { ...allNight[day], name: "晚班", room: [] },
              midnight: { ...allMidnight[day], name: "夜班", room: [] }
            }
          };
          ["morning", "night", "midnight"].forEach((eventName) => {
            const event = oneDay.events[eventName];
            Object.keys(event.department).forEach((item) => {
              const temp = { room: item, persons: [...event.department[item]] };
              event.room.push(temp);
            });
          });
          this.scheduleData.push(oneDay);
        }
      } catch (e) {
        showWindowMessage(3, "响应失败, 请重新尝试", this);
      }
    },
  },
};
